/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";

interface Props {
  lotUsageDetails: any;
  t: any;
}

const LotUsageInventoryCards: React.FC<Props> = ({
  lotUsageDetails,
  t
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm flex items-center justify-between">
            <div>
              <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-1">{t('mediaPowder.lotDetails.initialQty')}</p>
              <p className="text-3xl font-black text-[#2D3E50]">{lotUsageDetails?.lot_size || "-"}</p>
            </div>
            <div className="w-14 h-14 rounded-2xl bg-slate-50 flex items-center justify-center">
              <span className="material-symbols-outlined text-2xl text-slate-300">{t('mediaPowder.icons.inventory2')}</span>
            </div>
          </div>
          <div className="bg-[#2D3E50] p-6 rounded-2xl shadow-xl flex items-center justify-between text-white relative overflow-hidden">
            <div className="relative z-10">
              <p className="text-[10px] font-black text-white/40 uppercase tracking-[0.2em] mb-1">{t('mediaPowder.lotDetails.remainingBalance')}</p>
              <p className="text-5xl font-black text-[#10B981] drop-shadow-sm">{lotUsageDetails?.remaining_quantity || "-"}</p>
            </div>
            <div className="w-14 h-14 rounded-2xl bg-white/5 flex items-center justify-center relative z-10">
              <span className="material-symbols-outlined text-2xl text-white/20">{t('mediaPowder.icons.account_balance_wallet')}</span>
            </div>
          </div>
        </div>
  );
};

export default LotUsageInventoryCards;